export default __webpack_public_path__ + "static/media/streamer_avatar6.dc746af4.png";